var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Col } from "react-bootstrap";
var StyledCol = styled(Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 30px auto;\n  float: none;\n"], ["\n  margin: 30px auto;\n  float: none;\n"])));
// using style to avoid react warning on DOM element
var WrapperCol = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return React.createElement(StyledCol, __assign({ style: { maxWidth: getWidth(size) } }, props));
};
function getWidth(size) {
    switch (size) {
        case "large":
            return "1000px";
        case "medium":
            return "750px";
        default:
            return "450px";
    }
}
export default WrapperCol;
var templateObject_1;
